import React from "react"
import {useTranslation} from "react-i18next"
import AsyncSelect from "react-select/async"

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    minWidth: 200
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: 36,
    borderWidth: 0,
    boxShadow: "",
    fontSize: "1.7em",
    fontWeight: 500,
    cursor: "pointer"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#0d3356"
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: "3px 0 0 0",
    padding: "3px 6px",
    borderWidth: 0,
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)"
  }),
  option: (provided, state) => {
    const hoverStyle = {
      color: "#FFF",
      backgroundColor: "#0d3356"
    }
    const styles = {
      ...provided,
      padding: "3px 6px",
      borderRadius: "4px",
      fontSize: "1.7em",
      fontWeight: 500,
      color: "#0d3356",
      backgroundColor: "#FFF",
      cursor: "pointer",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "&:hover": hoverStyle
    }
    return state.isSelected ? {...styles, backgroundColor: "#e7ebee"} : styles
  }
}

export const TransactionTypeSelect = ({setTransactionType}) => {
  const {t} = useTranslation()
  const onChange = option => {
    setTransactionType(option && option.value ? option.value : "")
  }

  const loadOptions = (inputValue, callback) => {
    callback([
      {label: t("stockIn"), value: "StockIn"},
      {label: t("stockOut"), value: "StockOut"},
      {label: t("movement"), value: "Movement"}
    ])
  }

  return (
    <label>
      <span>{t("transactions.type")}</span>
      <AsyncSelect
        cacheOptions
        defaultOptions
        isClearable
        loadOptions={loadOptions}
        onChange={onChange}
        styles={customStyles}
        placeholder={t("selectPlaceholder")}
      />
    </label>
  )
}



// WEBPACK FOOTER //
// ./src/components/selects/TransactionTypeSelect.js